import { Presenter } from 'src/app/core/architecture/presenter';
import { GetEventItemFormResponse } from '../output-data/get-event-item-form.response';

export abstract class EventItemFormPresenter<T>
                extends Presenter<T> {
   public abstract showForm(response: GetEventItemFormResponse): void;
   public abstract showCreateResult(id: string);
}
